import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Check if URL contains ?id parameter
const params = new URLSearchParams(window.location.search);
const id = params.get('id');

if (id) {
  // If ?id exists → render the app
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  // If ?id not found → show message
  root.render(
    <div
      style={{
        textAlign: 'center',
        marginTop: '20%',
        fontSize: '1.5rem',
        color: '#555',
        fontFamily: 'sans-serif',
      }}
    >
      No Ticket Id Found
    </div>
  );
}

reportWebVitals();
